import { render, staticRenderFns } from "./UserRowActions.vue?vue&type=template&id=a72dfc28"
import script from "./UserRowActions.vue?vue&type=script&lang=ts"
export * from "./UserRowActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports